import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/auth";
import { AiOutlineClose } from "react-icons/ai";
import {
  IoDocumentAttachOutline,
  IoDocumentAttachSharp,
  IoLocationOutline,
  IoPersonRemove,
  IoTrash,
} from "react-icons/io5";
import { toast } from "react-toastify";
import ReactLoading from "react-loading";
import config from "../../config";

export default function ModalUpdateTable({
  closeModal,
  _dataLocacao,
  vendedores,
  id_event,
  id_map,
  updateLocalBoxes,
  openModalTransfer,
}) {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [dataLocacao, setDataLocacao] = useState(null);
  const [formData, setFormData] = useState({
    id_event,
    id_map,
    id_locacao: _dataLocacao?._id,
    status: _dataLocacao?.status || "disponivel",
    comprador: _dataLocacao?.comprador || "",
    vendedor: _dataLocacao?.vendedor || "",
    vendedor_nome: _dataLocacao?.vendedor_nome || "",
    valor_total_locacao: _dataLocacao?.valor_total_locacao || 0,
    valor_recebido: _dataLocacao?.valor_recebido || 0,
    anotacoes_financeiras: _dataLocacao?.anotacoes_financeiras || "",
    lugares: _dataLocacao?.lugares || [],
    formas_de_pagamento: _dataLocacao?.formas_de_pagamento || [],
  });

  useEffect(() => {
    if (_dataLocacao?._id) getDataLocacao(_dataLocacao?._id);
  }, [_dataLocacao?._id]);

  const getDataLocacao = async (idLocacao) => {
    try {
      setLoading(true);
      const res = await fetch(`${config.urlServer}/event/get-data-locacao`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: user.email,
          token: user.token,
          id_map,
          id_locacao: idLocacao,
        }),
      });
      const json = await res.json();
      setDataLocacao(json.locacao);
      setFormData((prev) => ({ ...prev, ...json.locacao }));
      setLoading(false);
    } catch (err) {
      toast.error("Erro ao carregar dados.");
      setLoading(false);
    }
  };

  const _updateTable = async (data_edit) => {
    try {
      setLoading(true);
      const res = await fetch(`${config.urlServer}/event/edit-locacao`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: user.email,
          token: user.token,
          data_edit,
        }),
      });
      const json = await res.json();
      toast.success("Locação atualizada!");
      updateLocalBoxes(_dataLocacao._id, json.locacao);
      closeModal();
    } catch {
      toast.error("Erro ao atualizar locação.");
      setLoading(false);
    }
  };

  const updateTable = async (data_edit, manterModalAberto) => {
    try {
      setLoading(true);

      const res = await fetch(
        `${config.urlServer}/event/update-locacao-completa`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            email: user.email,
            token: user.token,
          },
          body: JSON.stringify({ data_edit }),
        },
      );

      const json = await res.json();
      if (!res.ok) throw new Error(json.error || "Erro ao salvar locação");

      toast.success("Locação e pagamentos atualizados com sucesso!");
      updateLocalBoxes(_dataLocacao._id, json.locacao_atualizada);
      if (!manterModalAberto) {
        closeModal();
      }
      // ;
    } catch (err) {
      console.error(err);
      toast.error("Erro ao salvar locação." + err);
    } finally {
      setLoading(false);
    }
  };

  // Atualiza valor recebido com base na soma das formas de pagamento
  const recalcValorRecebido = (formas) => {
    const total = formas.reduce(
      (sum, item) => sum + parseFloat(item.valor || 0),
      0,
    );
    setFormData((prev) => ({
      ...prev,
      formas_de_pagamento: formas,
      valor_recebido: total,
    }));
  };

  const addFormaPagamento = () => {
    const novasFormas = [
      ...formData.formas_de_pagamento,
      {
        tipo: "",
        valor: 0,
        data_pagamento: new Date().toISOString().split("T")[0],
      },
    ];
    recalcValorRecebido(novasFormas);
  };

  const updateFormaPagamento = (i, field, value) => {
    const clone = [...formData.formas_de_pagamento];
    clone[i][field] = value;
    recalcValorRecebido(clone);
  };

  const removeFormaPagamento = (i) => {
    const clone = [...formData.formas_de_pagamento];
    clone.splice(i, 1);
    recalcValorRecebido(clone);
  };

  const addLugar = () => {
    setFormData((prev) => ({
      ...prev,
      lugares: [...prev.lugares, { nome: "", documento: "" }],
    }));
  };

  const removeLugar = (index) => {
    const updated = [...formData.lugares];
    updated.splice(index, 1);
    setFormData({ ...formData, lugares: updated });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    console.log(formData.lugares);
    if (!formData.lugares || formData.lugares.length === 0) {
      setFormData((prev) => ({
        ...prev,
        valor_total_locacao: 0,
      }));
      return;
    }

    const total = formData.lugares.reduce(
      (sum, lugar) => sum + Number(formData.valor_por_lugar || 0),
      0,
    );

    setFormData((prev) => ({
      ...prev,
      valor_total_locacao: total,
    }));
  }, [formData.lugares]);

  useEffect(() => {
    // console.log(dataLocacao);
    if (dataLocacao) {
      if (!user.admin) {
        if (user.email !== dataLocacao?.vendedor) {
          closeModal();
          toast.error(
            "Você pode interagir somente com as mesas que estão atribuidas ao seu usuário.",
          );
        }
      }
    }
  }, [dataLocacao]);

  if (loading || !dataLocacao)
    return (
      <div className="flex items-center justify-center h-64">
        <ReactLoading
          type="spinningBubbles"
          color="#0f766e"
          height={80}
          width={80}
        />
      </div>
    );
const total = Number(formData.valor_total_locacao || 0);
const recebido = Number(formData.valor_recebido || 0);

const excedente = recebido > total ? recebido - total : 0;
const pendente = recebido >= total ? 0 : total - recebido;


  return (
    <div className="bg-white rounded-lg shadow-lg w-full max-w-6xl h-full overflow-hidden relative border border-gray-300 flex flex-col">
      {/* HEADER FIXO */}

      <div className="sticky top-0 border-b border-gray-400 p-2">
        <header className="z-20 bg-white flex justify-between items-center  px-8 py-4 shadow-sm">
          <div className="flex items-center gap-2">
            <IoLocationOutline className="text-gray-700" size={22} />
            <h2 className="text-lg font-semibold">
              Locação nº{" "}
              <span className="text-emerald-700">{dataLocacao?.numero}</span>
            </h2>
          </div>
          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-red-600"
          >
            <AiOutlineClose size={24} />
          </button>
        </header>

        {/* STATUS */}
        <div className="flex gap-2">
          {["disponivel", "reservado", "vendido"].map((s) => {
            const bgColor =
              s === "vendido"
                ? "var(--grass)"
                : s === "reservado"
                ? "var(--rotary-gold)"
                : s === "disponivel"
                ? "var(--cardinal)"
                : "#eee";

            return (
              <button
                key={s}
                type="button"
                onClick={() => setFormData({ ...formData, status: s })}
                style={{
                  backgroundColor:
                    formData.status === s ? bgColor : "transparent",
                  color: formData.status === s ? "#fff" : "#000",
                  borderColor: formData.status === s ? bgColor : "#ccc",
                  boxShadow:
                    formData.status === s ? "0 0 5px rgba(0,0,0,0.2)" : "none",
                }}
                className={`flex-1 py-1 rounded-md border font-medium transition-all hover:bg-gray-100`}
              >
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            );
          })}
        </div>
      </div>
      {/* CONTEÚDO SCROLLÁVEL */}
      <div className="flex-1 overflow-y-auto px-8 py-4 space-y-6">
        {/* VENDEDOR / COMPRADOR */}
        <div className="grid grid-cols-2 gap-4">
          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Vendedor</span>
            <select
              name="vendedor"
              value={formData.vendedor}
              onChange={(e) => {
                const v = vendedores.find((x) => x.email === e.target.value);
                setFormData({
                  ...formData,
                  vendedor: v?.email || "",
                  vendedor_nome: v?.nome || "",
                });
              }}
              className="border border-gray-400 rounded p-2"
            >
              <option value="">Selecione...</option>
              {vendedores.map((v) => (
                <option key={v.email} value={v.email}>
                  {v.nome}
                </option>
              ))}
            </select>
          </label>

          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Comprador</span>
            <input
              type="text"
              name="comprador"
              value={formData.comprador}
              onChange={handleInputChange}
              className="border border-gray-400 rounded p-2"
              placeholder="Nome do comprador"
            />
          </label>
        </div>

        {/* LUGARES */}
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="font-medium text-sm">Lugares</span>
            <button
              type="button"
              // TODO: ajustar valores
              onClick={() =>
                setFormData({
                  ...formData,
                  lugares: [...formData.lugares, { nome: "", documento: "" }],
                })
              }
              className="text-xs bg-emerald-600 text-white px-3 py-1 rounded hover:bg-emerald-700"
            >
              + Adicionar lugar
            </button>
          </div>

          <div className="grid grid-cols-2 gap-2 border border-gray-400 rounded p-3 bg-gray-50 max-h-40 overflow-y-auto">
            {formData.lugares.map((l, i) => (
              <div key={i} className="flex items-center gap-2 text-xs">
                <span>{i + 1}.</span>
                <input
                  type="text"
                  value={l.nome}
                  onChange={(e) => {
                    const updated = [...formData.lugares];
                    updated[i].nome = e.target.value;
                    setFormData({ ...formData, lugares: updated });
                  }}
                  className="border border-gray-400 rounded p-1 flex-1"
                  placeholder="Nome"
                />
                <input
                  type="text"
                  value={l.documento}
                  onChange={(e) => {
                    const updated = [...formData.lugares];
                    updated[i].documento = e.target.value;
                    setFormData({ ...formData, lugares: updated });
                  }}
                  className="border border-gray-400 rounded p-1 w-1/2"
                  placeholder="Doc."
                />
                <button
                  type="button"
                  onClick={() => {
                    const updated = [...formData.lugares];
                    updated.splice(i, 1);
                    setFormData({ ...formData, lugares: updated });
                  }}
                  className="bg-red-500 text-white rounded p-1 hover:bg-red-600"
                >
                  <IoPersonRemove size={14} />
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* FORMAS DE PAGAMENTO */}
        <div className="flex flex-col">
          <div className="flex w-full justify-between items-center mb-2">
            <span className="font-medium text-sm">Formas de pagamento</span>
            <button
              type="button"
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  formas_de_pagamento: [
                    ...prev.formas_de_pagamento,
                    {
                      tipo: "",
                      valor: 0,
                      data_pagamento: new Date().toISOString().split("T")[0],
                      observacao: "",
                    },
                  ],
                }))
              }
              className="text-xs bg-emerald-600 text-white px-3 py-1 rounded hover:bg-emerald-700"
            >
              + Adicionar
            </button>
          </div>

          {formData.formas_de_pagamento.map((fp, i) => (
            <div
              key={i}
              className="grid grid-cols-7 gap-2 mb-2 text-xs items-center border border-gray-300 rounded p-2"
            >
              <select
                value={fp.tipo}
                onChange={(e) => {
                  const updated = [...formData.formas_de_pagamento];
                  updated[i].tipo = e.target.value;
                  setFormData({ ...formData, formas_de_pagamento: updated });
                }}
                className="border border-gray-400 rounded p-1 w-auto"
              >
                <option value="">Tipo</option>
                <option value="dinheiro">Dinheiro</option>
                <option value="pix">Pix</option>
                <option value="cheque">Cheque</option>
                <option value="outro">Outro</option>
              </select>

              <input
                type="number"
                value={fp.valor}
                onChange={(e) => {
                  const updated = [...formData.formas_de_pagamento];
                  updated[i].valor = e.target.value;
                  const total = updated.reduce(
                    (sum, item) => sum + parseFloat(item.valor || 0),
                    0,
                  );
                  setFormData({
                    ...formData,
                    formas_de_pagamento: updated,
                    valor_recebido: total,
                  });
                }}
                className="border border-gray-400 rounded p-1"
                placeholder="Valor"
              />

              <input
                type="date"
                value={fp.data_pagamento}
                onChange={(e) => {
                  const updated = [...formData.formas_de_pagamento];
                  updated[i].data_pagamento = e.target.value;
                  setFormData({ ...formData, formas_de_pagamento: updated });
                }}
                className="border border-gray-400 rounded p-1"
              />

              <input
                type="text"
                value={fp.observacao || ""}
                onChange={(e) => {
                  const updated = [...formData.formas_de_pagamento];
                  updated[i].observacao = e.target.value;
                  setFormData({ ...formData, formas_de_pagamento: updated });
                }}
                className="border border-gray-400 rounded p-1 w-auto"
                placeholder="Observação"
              />
              <div className="flex items-center gap-4">
                <input
                  type="file"
                  accept="image/*,.pdf"
                  onChange={async (e) => {
                    const file = e.target.files[0];
                    if (!file) return;

                    const fp = formData.formas_de_pagamento[i];
                    const formDataFile = new FormData();
                    formDataFile.append("file", file);
                    formDataFile.append("id_map", id_map);
                    formDataFile.append("id_locacao", formData.id_locacao);
                    if (fp._id) formDataFile.append("id_forma_pagamento", fp._id);
                    formDataFile.append("tipo", fp.tipo || "outro");
                    formDataFile.append("valor", fp.valor || 0);
                    formDataFile.append(
                      "data_pagamento",
                      fp.data_pagamento || new Date().toISOString(),
                    );
                    formDataFile.append("observacao", fp.observacao || "");
                    
                    try {
                      const res = await fetch(
                        `${config.urlServer}/event/upload-comprovante-locacao`,
                        {
                          method: "POST",
                          headers: {
                            Authorization: `Bearer ${user.token}`,
                          },
                          body: formDataFile,
                        },
                      );

                      const data = await res.json();

                      if (!res.ok)
                        throw new Error(data.error || "Falha no upload");

                      const updated = [...formData.formas_de_pagamento];
                      updated[i].comprovante_url = data.comprovante_url_virtual;

                      setFormData({
                        ...formData,
                        formas_de_pagamento: updated,
                        valor_recebido: updated.reduce(
                          (s, f) => s + parseFloat(f.valor || 0),
                          0,
                        ),
                      });

                      getDataLocacao(_dataLocacao?._id);

                      toast.success("Pagamento registrado com sucesso!");
                    } catch (error) {
                      console.error(error);
                      toast.error(
                        "Erro ao enviar o comprovante e registrar o pagamento.",
                      );
                    }
                  }}
                  className="border border-gray-400 rounded p-1"
                />

                {fp.comprovante_url_virtual ? (
                  <a
                    href={fp.comprovante_url_virtual}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline text-center"
                  >
                    <IoDocumentAttachSharp size={20} />
                  </a>
                ) : (
                  <a
                    // href={fp.comprovante_url_virtual}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 underline text-center hover:cursor-not-allowed"
                  >
                    <IoDocumentAttachSharp size={20} />
                  </a>
                )}

                <button
                  type="button"
                  onClick={async () => {
                    if (!fp._id) return;
                    const confirma = window.confirm(
                      "Tem certeza que deseja deletar este recebimento?",
                    );
                    if (!confirma) return;
                    try {
                      const res = await fetch(
                        `${config.urlServer}/event/delete-comprovante-locacao`,
                        {
                          method: "POST",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            email: user.email,
                            token: user.token,
                          },
                          body: JSON.stringify({
                            id_map,
                            id_locacao: formData.id_locacao,
                            id_forma_pagamento: fp._id,
                          }),
                        },
                      );
                      const data = await res.json();
                      if (!res.ok) throw new Error(data.error);
                      toast.success("Pagamento removido com sucesso!");
                      setFormData((prev) => ({
                        ...prev,
                        formas_de_pagamento: prev.formas_de_pagamento.filter(
                          (f) => f._id !== fp._id,
                        ),
                        valor_recebido: prev.formas_de_pagamento
                          .filter((f) => f._id !== fp._id)
                          .reduce((s, f) => s + parseFloat(f.valor || 0), 0),
                      }));
                    } catch (err) {
                      toast.error("Erro ao remover comprovante.");
                    }
                  }}
                  className="text-white rounded p-2 w-[30px]"
                >
                  <IoTrash size={20} className="text-red-600" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* VALORES */}
        {/* <div className="grid grid-cols-4 gap-4">
          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Lugares</span>
            <input
              type="number"
              name="valor_por_lugar"
              value={formData.valor_por_lugar}
              onChange={handleInputChange}
              className="border border-gray-400 rounded p-2 bg-gray-100 cursor-not-allowed"
            />
          </label>
          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Valor por lugar</span>
            <input
              type="number"
              name="valor_por_lugar"
              value={formData.valor_por_lugar}
              onChange={handleInputChange}
              className="border border-gray-400 rounded p-2 bg-gray-100 cursor-not-allowed"
            />
          </label>
          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Valor total</span>
            <input
              type="number"
              name="valor_total_locacao"
              value={formData.valor_total_locacao}
              onChange={handleInputChange}
              className="border border-gray-400 rounded p-2 bg-gray-100 cursor-not-allowed"
            />
          </label>

          <label className="flex flex-col text-sm">
            <span className="font-medium mb-1">Valor recebido</span>
            <input
              type="number"
              name="valor_recebido"
              value={formData.valor_recebido}
              readOnly
              className="border border-gray-400 rounded p-2 bg-gray-100 cursor-not-allowed"
            />
          </label>
        </div> */}
<div className="flex flex-col gap-3 sm:flex-row sm:items-stretch">
  {/* BLOCO 1 — DADOS DA MESA */}
  <div className="grid flex-1 grid-cols-3 gap-3">
    <div className="rounded-md border bg-white p-3">
      <span className="text-[11px] uppercase tracking-wide text-gray-500">
        Lugares
      </span>
      <div className="mt-1 text-xl font-semibold text-gray-900">
        {formData.lugares.length}
      </div>
    </div>

    <div className="rounded-md border bg-white p-3">
      <span className="text-[11px] uppercase tracking-wide text-gray-500">
        Valor por lugar
      </span>
      <div className="mt-1 text-xl font-semibold text-gray-900">
        R$ {formData.valor_por_lugar}
      </div>
    </div>

    <div className="rounded-md border bg-white p-3">
      <span className="text-[11px] uppercase tracking-wide text-gray-500">
        Total da mesa
      </span>
      <div className="mt-1 text-xl font-semibold text-gray-900">
        R$ {total}
      </div>
    </div>
  </div>

  {/* DIVISÃO */}
  <div className="hidden sm:flex w-px bg-gray-300 mx-2" />

  {/* BLOCO 2 — FINANCEIRO */}
  <div className="grid flex-1 grid-cols-2 gap-3">
<div
  className={`rounded-md border p-3 ${
    excedente > 0
      ? "border-orange-400 bg-orange-50"
      : pendente > 0
      ? "border-red-300 bg-red-50"
      : "border-gray-300 bg-gray-100"
  }`}
>
  <span
    className={`text-[11px] uppercase tracking-wide ${
      excedente > 0
        ? "text-orange-600"
        : pendente > 0
        ? "text-red-600"
        : "text-gray-500"
    }`}
  >
    {excedente > 0 ? "Valor excedente" : "Pendente a receber"}
  </span>

  <div
    className={`mt-1 text-xl font-bold ${
      excedente > 0
        ? "text-orange-700"
        : pendente > 0
        ? "text-red-700"
        : "text-gray-600"
    }`}
  >
    R$ {excedente > 0 ? excedente : pendente}
  </div>

  {/* ALERTA */}
  {excedente > 0 && (
    <p className="mt-1 text-[11px] text-orange-700 font-medium">
      ⚠️ Valor recebido maior que o total da mesa
    </p>
  )}
</div>


    <div className="rounded-md border border-emerald-300 bg-emerald-50 p-3">
      <span className="text-[11px] uppercase tracking-wide text-emerald-600">
        Recebido
      </span>
      <div className="mt-1 text-xl font-bold text-emerald-700">
        R$ {recebido}
      </div>
    </div>
  </div>
</div>


        {/* ANOTAÇÕES GERAIS */}
        <label className="flex flex-col text-sm">
          <span className="font-medium mb-1">Anotações gerais</span>
          <textarea
            name="anotacoes_financeiras"
            value={formData.anotacoes_financeiras}
            onChange={handleInputChange}
            className="!border border-gray-400 rounded p-2"
            placeholder="Digite observações gerais..."
          />
        </label>
      </div>

      {/* FOOTER FIXO */}
      <footer className="sticky bottom-0 bg-white border-t border-gray-400 px-4 py-2 flex flex-col justify-between items-center shadow-inner gap-1">
        {/* BARRA DE PORCENTAGEM */}
        <div className="w-full">
          {(() => {
            const total = parseFloat(formData.valor_total_locacao) || 0;
            const recebido = parseFloat(formData.valor_recebido) || 0;
            const percent =
              total > 0 ? Math.min((recebido / total) * 100, 100) : 0;

            const getColor = () => {
              if (percent < 40) return "bg-red-500";
              if (percent < 80) return "bg-yellow-500";
              return "bg-emerald-600";
            };

            return (
              <div className="flex flex-col gap-1">
                <div className="flex justify-between text-xs font-medium text-gray-600">
                  <span>Recebido:</span>
                  <span>{percent.toFixed(1)}%</span>
                </div>
                <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className={`h-3 ${getColor()} transition-all duration-500`}
                    style={{ width: `${percent}%` }}
                  />
                </div>
              </div>
            );
          })()}
        </div>
        <div className="w-full flex justify-between items-center shadow-inner">
          <button
            type="button"
            onClick={openModalTransfer}
            className="border border-gray-500 text-gray-700 px-6 py-2 rounded hover:bg-gray-100 transition"
          >
            Transferir
          </button>
          <div className="flex gap-2">
            <button
              onClick={() => updateTable(formData, true)}
              className="border border-emerald-600 text-emerald-600 px-8 py-2 rounded hover:bg-emerald-700 hover:text-white transition"
            >
              Salvar e permanecer
            </button>
            <button
              onClick={() => updateTable(formData, false)}
              className="bg-emerald-600 text-white px-8 py-2 rounded hover:bg-emerald-700 transition"
            >
              Salvar e sair
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}
